import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Button, Form} from 'antd';
import {PasswordRuler} from '@dofleini/validator';
import Password from '../../components/Password';
import {Link} from 'react-router-dom';

function NewPasswordFrom({handleSubmit, loading, hasError}) {
  const {t} = useTranslation('authentication');
  return (
    <Form
      name="normal_login"
      layout={'vertical'}
      className="login-form"
      onFinish={handleSubmit}
    >

      <Form.Item
        name="password"
        label={t('login.password')}
        validateStatus={hasError ? 'error' : undefined}
        rules={[
          {required: true},
          PasswordRuler
        ]}
      >
        <Password
          disabled={loading || hasError}
          lateral={false}
          size={'large'}
          placeholder={t('password')}
        />
      </Form.Item>


      <Form.Item>
        <div className={'flex flex-row'}>
          {
            !hasError ? <Button loading={loading} className={'w-full'}
              disabled={loading || hasError}
              size={'large'}
              type="primary" htmlType="submit">{t('recovery.save')}</Button>
              :
              <Link to={'/recovery_password'} className={'flex-grow'}>
                <Button loading={loading} className={'w-full'}
                  disabled={loading}
                  size={'large'}
                  type="primary">
                  {t('recovery.newLink')}
                </Button>
              </Link>
          }
        </div>


      </Form.Item>

    </Form>
  );
}

export default NewPasswordFrom;

NewPasswordFrom.propTypes = {
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
  hasError: PropTypes.bool,
};
